var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTerminos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 123,
    viewBox: "0 0 112 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7123 0C76.5603 13.215 95.3943 19.467 111.558 17.989C114.381 75.087 93.2953 108.807 55.9283 122.88C19.8433 109.708 -1.50069 77.439 0.0823139 17.123C19.0573 18.116 37.6733 14.014 55.7123 0ZM33.7833 66.775C32.6033 65.765 32.4653 63.989 33.4743 62.808C34.4853 61.627 36.2613 61.49 37.4413 62.499L48.9353 72.374L74.1153 44.69C75.1623 43.54 76.9433 43.456 78.0943 44.502C79.2433 45.548 79.3273 47.329 78.2813 48.48L51.2613 78.188L51.2593 78.186C50.2393 79.307 48.5083 79.422 47.3493 78.43L33.7833 66.775Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTerminos);
export default __webpack_public_path__ + "static/media/iconTerminos.685d066cfb9b4e0a5d6f995698ebf31c.svg";
export { ForwardRef as ReactComponent };